/**
 * localStorage 存储键名常量
 */

export const STORAGE_KEYS = {
//   // 用户相关
//   USER_TOKEN: 'user_token',
//   USER_INFO: 'user_info',
  
  // 系统设置相关
//   THEME: 'theme',
//   LANGUAGE: 'language',
  
  // 其他业务相关
  // 随机提示词不再自动显示
  RANDOM_PROMPT_AUTO_SHOW_KEY: 'randomPromptAutoShow',
  // 新用户引导B组是否已显示（存储标识）
  HAS_NEW_USER_GUIDE_GROUP_B_DISPLAYED: 'hasNewUserGuideGroupBDisplayed',
  /** 团队个人额度 95% 预警 toast 的最近提示日期（YYYY-MM-DD） */
  TEAM_QUOTA_WARN_DATE: 'team_quota_warn_date',
  /** 全能拆分图层位置（会话级，按 clientId 存） */
  PINO_SPLIT_LAYER_POSITIONS: 'pinoSplitLayerPositions',
  /** 画布跨标签页复制的图层数据信封（覆盖式，仅保留最近一次复制） */
  PINO_CANVAS_COPY: 'pinoCanvasCopy',
} as const;

// 类型定义
export type StorageKey = keyof typeof STORAGE_KEYS; 